import React, { useState, useEffect, useMemo, useRef } from "react";
import ShimmerLoaderSeat from "../../components/ShimmerLoaderSeat";
import { Clock, ArrowRight, Plane, User, CreditCard, CheckCircle, Info, Calendar } from "lucide-react";
import { addYears, subDays, format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from 'react-hot-toast';
import {
  fetchValidateFare, fetchSeatMap, selectFareValidation, selectFareValidationStatus,
  SavePassenger, fetchMemberList
} from "./flightSlice";
import { resetFareValidation, resetSaveItinerary, resetBookingDetails } from "./flightSlice";
import { selectCurrentUser } from "../auth/authSlice";
import ItineraryLoader from "../../components/ItineraryLoader";
import FareSummary from "./FareSummary";
import countrycode from "../../data/countrycode.json";
import Moment from 'moment';
import useDocumentTitle from "../../hooks/useDocumentTitle";
import { DateInput } from "@mantine/dates";
import Cellempty from "../../components/Cellempty";
import SeatSelection from "../../components/SeatSelection";
import '../../../src/seatmap.css';
import { useParsedContent } from "../../hooks/useParsedContent";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);


// import {
//   validateFare,
// } from "./flightSlice";

function getDobRange(paxType, travelDate) {
  let minDate, maxDate;

  switch (paxType) {
    case "ADULT":
      // Adult = > 12 years, up to 100 years
      maxDate = new Date(travelDate.getFullYear() - 12, travelDate.getMonth(), travelDate.getDate());
      minDate = new Date(travelDate.getFullYear() - 100, travelDate.getMonth(), travelDate.getDate());
      break;

    case "CHILD":
      // Child = between 2 and 12 years
      maxDate = new Date(travelDate.getFullYear() - 2, travelDate.getMonth(), travelDate.getDate());
      minDate = new Date(travelDate.getFullYear() - 12, travelDate.getMonth(), travelDate.getDate());
      break;

    case "INFANT":
      // Infant = < 2 years
      maxDate = travelDate; // Not later than travel date
      minDate = new Date(travelDate.getFullYear() - 2, travelDate.getMonth(), travelDate.getDate());
      break;

    default:
      // fallback = allow up to 100 years old
      maxDate = travelDate;
      minDate = new Date(travelDate.getFullYear() - 100, travelDate.getMonth(), travelDate.getDate());
  }

  return { minDate, maxDate };
}

function getPassportIssueRange() {
  const today = new Date();
  const minDate = new Date(today.getFullYear() - 10, today.getMonth(), today.getDate()); // 10 years back
  const maxDate = today; // cannot be in future
  return { minDate, maxDate };
}

function getPassportExpiryRange(travelDate) {
  // min = travel date + 6 months
  const minDate = new Date(travelDate);
  minDate.setMonth(minDate.getMonth() + 6);

  // max = travel date + 20 years
  const maxDate = new Date(
    travelDate.getFullYear() + 20,
    travelDate.getMonth(),
    travelDate.getDate()
  );

  return { minDate, maxDate };
}


export default function FlightItinerary() {
  useDocumentTitle('Flight Itinerary');
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const fareValidation = useSelector(selectFareValidation);
  const fareValidationStatus = useSelector(selectFareValidationStatus);
  const user = useSelector(selectCurrentUser)
  const targetRef = useRef(null);
  // const isLoading = flightStatus === "loading";
  // Mock timer (replace with real session timeout logic)
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 min session
  const [booking, setBooking] = useState([]); // 15 min session

  const [SelectedBaggage, setSelectedBaggage] = useState([]);
  const [SelectedMeals, setSelectedMeals] = useState([]);
  const [SelectedSeats, setSelectedSeats] = useState([]);
  const [TotalBagPrice, setTotalBagPrice] = useState(0)
  const [TotalMealPrice, setTotalMealPrice] = useState(0)
  const [BookingData, setBookingData] = useState([]);
  const [fare, setfare] = useState([]);
  const [TotalSSR, setTotalSSR] = useState(0)
  const [Savepaxloading, setSavepax] = useState(false)
  const [SeatPrice, setSeatPrice] = useState(0);
  const [SeatPriceTemp, setSeatPriceTepm] = useState(0);
  const [open, setOpen] = useState(false);
  const [FareChange, setFareChange] = useState(0);
  const [totalPax, settotalPax] = useState(0);
  const [TravelDate, setTravelDate] = useState(new Date());
  const [Supplier, setSupplier] = useState(0);
  const [CurrencyTitle, setCurrencyTitle] = useState('INR');
  const [sessionTime, setsessionTime] = useState([]);
  const [params, setparams] = useState([]);
  const [SeatData, setSeatData] = useState([]);
  const [SeatLoading, setSeatLoading] = useState(false);
  const [SeatDataSuccess, setSeatDataSuccess] = useState(false);
  const [BookOffline, setBookOffline] = useState(false);
  const [memberDetails, setMemberDetails] = useState([
    { fname: '', lname: '', cid: '', title: '', dob: '', passno: '', passisse: '', passexp: '', passnational: 'IN', isdobr: false, checked: false, addonns: false, selectedBad: 'NA', selectedMeal: 'NA' },
  ])

  const dobRef = useRef(null);

  const formatDateInput = (e) => {
    let value = e.target.value;

    // Remove all non-digits
    let digits = value.replace(/\D/g, "");

    // Limit to 8 digits max
    digits = digits.slice(0, 8);

    // Clamp DD: max 31
    if (digits.length >= 2) {
      let day = parseInt(digits.slice(0, 2), 10);
      if (day > 31) day = 31;
      if (day < 1 && digits.length === 2) day = 1;
      digits = String(day).padStart(2, "0") + digits.slice(2);
    }

    // Clamp MM: max 12
    if (digits.length >= 4) {
      let month = parseInt(digits.slice(2, 4), 10);
      if (month > 12) month = 12;
      if (month < 1 && digits.length >= 4) month = 1;
      digits = digits.slice(0, 2) + String(month).padStart(2, "0") + digits.slice(4);
    }

    // Auto-insert dashes: DD-MM-YYYY
    let formatted = digits;
    if (digits.length > 4) {
      formatted = digits.slice(0, 2) + "-" + digits.slice(2, 4) + "-" + digits.slice(4);
    } else if (digits.length > 2) {
      formatted = digits.slice(0, 2) + "-" + digits.slice(2);
    }

    e.target.value = formatted;
  };
  const [currency, setCurrency] = useState({
    CurrencyRate: "1",
    CurrencyTitle: "INR",
    CurrencyId: 1,
  }); // 15 min session

  const FormData = useMemo(() => {
    const ItineraryInfo = JSON.parse(localStorage.getItem('ItineraryInfo'))
    const params = new URLSearchParams(location.search);
    const Request = {
      priceIds: params.get("PriceID").split(',')
    }
    return {
      Request: Request,
      searchId: params.get("searchId") || "",
      reissue: (params.get("reissue") === "true") ? true : false || false,
      currency: currency,
      ItineraryInfo: ItineraryInfo,
    };
  }, [location.search]);
  const fetchMember = async () => {
    const response = await dispatch(
      fetchMemberList({ FormData })
    ).unwrap();
    setCustomerMember(response.data.data);
  };


  useEffect(() => {
    // console.log(FormData);
    // return false;

    if (FormData && currency) {
      setSelectedBaggage([])
      setSelectedMeals([])
      setSelectedSeats([])
      targetRef?.current?.scrollIntoView({ behavior: "smooth" });
      dispatch(resetFareValidation());
      dispatch(resetSaveItinerary());
      dispatch(fetchValidateFare({ FormData, currency }));
      fetchMember()
    }
  }, [FormData, dispatch]);

  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     setTimeLeft((t) => (t > 0 ? t - 1 : 0));
  //   }, 1000);
  //   return () => clearInterval(timer);
  // }, []);

  const validationData = fareValidation || {};
  const validationStatus = fareValidationStatus || "idle";


  const isLoading = validationStatus === "loading";
  useEffect(() => {
    if (validationStatus === "succeeded" && validationData) {
      const data = validationData

      if (data.status.success) {
        if ((data.arrFlightData[0].Supplier !== 6 && data.arrFlightData[0].Supplier !== 11)) {
          getSeatMap()
        }

        localStorage.removeItem('timerSession');
        setBookingData(data.arrFlightData)
        setTravelDate(new Date(data.arrFlightData[0].FromUTCTime))
        setSupplier(data.arrFlightData[0].Supplier)
        setfare(data.fare)
        setBookOffline(data.fare.BookOffline)
        setFareChange(data.fare.TotalGrand)
        setMemberDetails(data.memberDetails)
        setCurrencyTitle(data.CurrencyTitle)
        setOpen(data.FareChange)
        setparams(data.params)
        settotalPax(parseInt(data.params?.searchQuery?.paxInfo?.ADULT) + parseInt(data.params?.searchQuery?.paxInfo?.CHILD))
        setsessionTime(data.isSessionTime)
        localStorage.setItem('timerSession', JSON.stringify(data.isSessionTime));
        // setOpen(true)

      } else {
        dispatch(resetFareValidation());
        dispatch(resetSaveItinerary());
        window.history.back();
        toast.error(data.message, { autoClose: 2000 });
      }
    } else if (validationStatus === "failed") {
      dispatch(resetFareValidation());
      dispatch(resetSaveItinerary());
      window.history.back();
      toast.error('Request flight is not longer available.Please try different flight', { autoClose: 2000 });
    }
  }, [validationStatus, validationData]);
  console.log(memberDetails);

  const getSeatMap = async () => {
    try {
      const APIPaxDetails = memberDetails
        .filter((member) => {
          // Validation: ensure title, fname, and lname are not empty
          if ((!member.title || !member.fname || !member.lname) && (Supplier === 6 || Supplier === 11)) {
            toast.error(`Pax with ${member.pax} - ${member.index} — missing required field(s):`, { autoClose: 2000 });
            throw new Error("Break the loop.");
          }
          return true;
        })
        .map((member) => ({
          PaxRefNumber: String(member.index),
          Title: (member.title.toUpperCase() === 'MASTER') ? 'Mstr' : member.title.toUpperCase(),
          PaxType: member.pax === "ADULT" ? "ADT"
            : member.pax === "CHILD" ? "CHD"
              : member.pax === "INFANT" ? "INF" : "",
          FirstName: member.fname.toUpperCase(),
          LastName: member.lname.toUpperCase(),
          passexp: member.passexp,
          passisse: member.passisse,
          passnational: member.passnational,
          passno: member.passno,
          DOB: member.dob,
        }));
      setSeatLoading(true)
      let RequestData = {
        BookingID: FormData.searchId,
        currency: FormData.currency,
        APIPaxDetails: APIPaxDetails,
      }
      const response = await dispatch(
        fetchSeatMap({ RequestData })
      ).unwrap();
      const Resultdata = response.data;

      if (Resultdata.status.success) {
        setSeatLoading(false)
        setSeatDataSuccess(Resultdata.status.success)
        setSeatData(Resultdata.data)
      } else {
        setSeatLoading(false)
        setSeatDataSuccess(Resultdata.status.success)
      }
    } catch (error) {
    }
  }

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  };
  const [data, setContactData] = useState({
    countryCode: (user?.UserData?.user) ? user?.UserData?.user?.countrycode : '91',
    email: (user?.UserData?.user) ? user?.UserData?.user?.email : '',
    mobile: (user?.UserData?.user) ? user?.UserData?.user?.mobile : '',
    gstnnumber: '',
    companyname: '',
    gstemail: '',
    gstphone: '',
    gstaddress: '',
    gststate: '',
    specialrequest: '',
    accepttnc: true,
    isgstapply: false,
  });

  const handleChange = (e) => {
    setContactData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const isgstapplyhandle = (event) => {
    const { value, checked } = event.target;
    setContactData(prev => ({
      ...prev,
      ['isgstapply']: checked
    }));
  }

  const handleFormChange = (event, index, date = null) => {

    let data = [...memberDetails];

    // make a copy of the specific object 
    let updatedMember = { ...data[index] };
    if (typeof event === "string") {
      updatedMember[event] = date;
      if (event === 'passisse') {
        const result = dayjs(date).add(10, "year").subtract(1, "day").format("YYYY-MM-DD");
        updatedMember['passexp'] = result;
      }
    } else {
      const { name, value, checked, type } = event.target;
      if (name === "checked" || name === "wchr") {
        updatedMember[name] = checked;
      } else {
        updatedMember[name] = value.toUpperCase();
      }
    }
    data[index] = updatedMember; // replace with updated copy
    setMemberDetails(data);
  };


  let BaggageArr = [];
  let MealArr = [];
  const Allsegment = [];
  {
    BookingData.length > 0 &&
      BookingData.map(item =>
      (
        item.Segments.map(val => {
          if (val.BAGGAGE) {
            val.BAGGAGE.forEach((bag) => {
              BaggageArr.push(bag);
            });
          }
          if (val.MEAL) {
            val.MEAL.forEach((meal) => {
              MealArr.push(meal);
            });
          }
          (
            Allsegment.push(val)
          )
        })
      ))
  }
  console.log(Allsegment);

  const [Frequentflyer, setFrequentflyer] = useState(false);
  const toggleFrequentflyer = () => setFrequentflyer(value => !value);
  const inputRef = useRef();
  const [nationality, setnationality] = useState(countrycode);
  const [CustomerMember, setCustomerMember] = useState([]);
  const [CustomerMem, setCustomerMem] = useState([]);
  const [CustomerMemberload, setCustomerMemberload] = useState(0);
  const SearchMember = (e, index, PaxType) => {

    let keyword = e.target.value
    const filteredData = CustomerMember.filter(
      (item) => item.PaxType == PaxType && (item.fname.toLowerCase().includes(keyword.toLowerCase()) || item.lname.toLowerCase().includes(keyword.toLowerCase()))
    );
    setCustomerMem(filteredData);
    setCustomerMemberload(index + 1)
  }

  // const handleMemberSelect = (event, index) => {
  //   console.log(index);
  //   console.log(event);
  //   let data = [...memberDetails];
  //   data[index]['fname'] = event.fname.toUpperCase();
  //   data[index]['lname'] = event.lname.toUpperCase();
  //   data[index]['title'] = event.title.toUpperCase();
  //   data[index]['passno'] = event.passno;
  //   data[index]['passisse'] = event.passisse;
  //   data[index]['passexp'] = event.passexp;
  //   data[index]['dob'] = event.dateofbirth;
  //   data[index]['passnational'] = event.passnational.toUpperCase();
  //   setMemberDetails(data);
  // }

  const handleMemberSelect = (event, index) => {

    setMemberDetails(prev =>
      prev.map((item, i) =>
        i === index
          ? {
            ...item,
            fname: event.fname?.toUpperCase() || '',
            lname: event.lname?.toUpperCase() || '',
            title: event.title?.toUpperCase() || '',
            passno: event.passno,
            passisse: event.passisse,
            passexp: event.passexp,
            dob: event?.dateofbirth || null,
            passnational: event.passnational?.toUpperCase() || ''
          }
          : item
      )
    );
  };

  const transformData = (inputData) => {
    let A = 1, C = 1, I = 1;
    const travellerInfo = inputData.map((pax) => {
      // Map salutation based on title
      let paxType = "";
      if (pax.PaxType === 1) {
        paxType = `ADULT${A}`;
        A++;
      } else if (pax.PaxType === 2) {
        paxType = `CHILD${C}`;
        C++;
      } else {
        paxType = `INFANT${I}`;
        I++;
      }
      let getSelected = getSelectedAddon(SelectedBaggage, SelectedMeals, paxType, BaggageArr, MealArr);
      const salutionMap = {
        'MR': '1',
        'MRS': '2',
        'MS': '3',
        'MASTER': '4',
        'MISS': '5'
      };

      // Map PaxType to pt format
      const ptMap = {
        '1': 'ADULT',
        '2': 'CHILD',
        '3': 'INFANT'
      };
      let SelectedSeat = pax.selectedSeat
      let SeatPrice = 0;
      if (SelectedSeat && typeof SelectedSeat === "object" && Object.keys(SelectedSeat).length > 0) {
        SeatPrice = Object.values(SelectedSeat).filter((seats) => Array.isArray(seats) && seats.length > 0).flat().reduce((sum, seat) => sum + (Number(seat.amount) || 0), 0);
      }
      console.log(getSelected);


      return {
        relation: "0",
        wchr: pax.wchr ? 1 : 0,
        salution: salutionMap[pax.title] || "1",
        title: pax.title,
        fname: pax.fname,
        lname: pax.lname,
        PaxType: pax.PaxType.toString(),
        pt: `${ptMap[pax.PaxType]}${pax.PaxType}`,
        FFdetail: pax.FFdetail || [],
        dob: (pax.isdobr) ? (pax.dob ? new Date(pax.dob).toISOString().split('T')[0] : null) : null,
        city: "",
        docid: pax.docid || "",
        address: "",
        nationality: "India",
        passno: pax.passno || "",
        passexp: pax.passexp || null,
        passisse: pax.passisse || null,
        passnational: pax.passnational || "IN",
        frequentFlyerno: "",
        SeatPrice: SeatPrice,
        SelectedSeat: pax.selectedSeat || null,
        MealPrice: getSelected?.MealPrice || 0,
        SelectedMeal: getSelected?.paxTypeMeal || null,
        BagPrice: getSelected?.BagPrice || 0,
        SelectedBag: getSelected?.paxTypeBag || null
      };
    });

    return travellerInfo;
  };
  const getSelectedAddon = (selectedBag, selectedMeal, paxType, BaggageArr, MealArr) => {
    let paxTypeBag = {};
    let paxTypeMeal = {};

    // ---------- BAGGAGE ----------
    if (selectedBag && selectedBag.length > 0) {
      selectedBag.forEach((val) => {
        const value = val.split("@@")[0]; // same as strstr($val, '@@', true)
        const valueEXP = value.split("_"); // [paxType, filterBy, sector]

        if (paxType === valueEXP[0]) {
          const filterBy = valueEXP[1];
          const sector = valueEXP[2];

          const bnew = BaggageArr.filter((item) => {
            const keyCode = item.Code + "@" + item.key;
            return keyCode === filterBy;
          });

          paxTypeBag[sector] = bnew;
        }
      });
    }

    // ---------- MEAL ----------
    if (selectedMeal && selectedMeal.length > 0) {
      selectedMeal.forEach((val) => {
        const value = val.split("@@")[0];
        const valueEXP = value.split("_");

        if (paxType === valueEXP[0]) {
          const filterBy = valueEXP[1];
          const sector = valueEXP[2];

          const mnew = MealArr.filter((item) => {
            const keyCode = item.Code + "@" + item.key;
            return keyCode === filterBy;
          });

          paxTypeMeal[sector] = mnew;
        }
      });
    }

    // ---------- PRICE CALC ----------
    let BagPrice = 0;
    Object.values(paxTypeBag).forEach((val) =>
      val.forEach((v) => (BagPrice += v.Price))
    );

    let MealPrice = 0;
    Object.values(paxTypeMeal).forEach((val) =>
      val.forEach((v) => (MealPrice += v.Price))
    );

    return {
      paxTypeBag,
      paxTypeMeal,
      BagPrice,
      MealPrice,
    };
  }

  const SavePaxSubmit = async (e) => {
    e.preventDefault();
    dispatch(resetSaveItinerary());
    dispatch(resetBookingDetails());
    let continueform = true;
    //const postData = { memberDetails, data, SelectedBaggage, SelectedMeals }

    if (data.mobile === '') {
      toast.error('Please enter mobile no.', { autoClose: 2000 });
      return false;
    }
    if (data.mobile?.length !== 10) {
      toast.error('Mobile number should be 10 digits!', { autoClose: 2000 });
      return false;
    }
    if (data.email === '') {
      toast.error('Please enter email ID', { autoClose: 2000 });
      return false;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)) {
      toast.error('Please valid email ID', { autoClose: 2000 });
      return false;
    }
    try {

      memberDetails.forEach((vl, key) => {
        let paxmsg = 'of passenger ' + (key + 1);
        if (vl.title === '') {
          toast.error('Select title ' + paxmsg, { autoClose: 2000 });
          continueform = false;
          throw new Error("Break the loop.");

        }
        if (vl.fname === '') {
          toast.error('Enter first name ' + paxmsg, { autoClose: 2000 });
          continueform = false;
          throw new Error("Break the loop.");

        }
        if (vl.lname === '') {
          toast.error('Enter last name ' + paxmsg, { autoClose: 2000 });
          continueform = false;
          throw new Error("Break the loop.");

        }
        if (vl.isdobr) {
          if (vl.dob === '' || vl.dob === 'null' || vl.dob === null) {
            toast.error('Enter Date Of Birth ' + paxmsg, { autoClose: 2000 });
            continueform = false;
            throw new Error("Break the loop.");

          } else {
            const dobString = vl.dob;
            const PaxType = vl.PaxType;
            const maxAge = 2;
            const dobMoment = Moment(dobString, 'YYYY-MM-DD')
            const today = Moment()
            const age = today.diff(dobMoment, 'years', true);

            if (PaxType == 1) {
              if (vl.IsDocIdM) {
                if (age < 60) {
                  toast.error('Adult age should be greater than 60 year ' + paxmsg, { autoclose: 2000 });
                  continueform = false;
                  throw new Error("Break the loop.");
                }
              } else {
                if (age < 12) {
                  toast.error('Adult age should be greater than 12 year ' + paxmsg, { autoclose: 2000 });
                  continueform = false;
                  throw new Error("Break the loop.");
                }
              }
            } else if (PaxType == 2) {
              if (age < 2 || age >= 12) {
                toast.error('Child age should be 2 years or less than 12 years ' + paxmsg, { autoclose: 2000 });
                continueform = false;
                throw new Error("Break the loop.");
              }
            } else {
              if (0 <= age && age <= maxAge) {
              } else {
                toast.error("Infant category age should be less than 2 years. Use correct category to book their ticket.", { autoclose: 200 });
                continueform = false;
                throw new Error("Break the loop.");
              }
            }
          }
        }

        if (vl.IsDocIdM) {
          if (vl.docid === '') {
            toast.error('Enter Document Details ' + paxmsg, { autoclose: 2000 });
            continueform = false;
            throw new Error("Break the loop.");
          }

        }
        if (vl.IsPassM) {
          if (vl.passnational === '') {
            toast.error('Select passport nationality ' + paxmsg, { autoclose: 2000 });
            continueform = false;
            throw new Error("Break the loop.");
          }
          if (vl.passno === '') {
            toast.error('Enter passport number ' + paxmsg, { autoclose: 2000 });
            continueform = false;
            throw new Error("Break the loop.");
          }
          if (vl.passisse === '' || vl.passisse === 'null' || vl.passisse === null) {
            toast.error('Enter Passport issue Date ' + paxmsg, { autoclose: 2000 });
            continueform = false;
            throw new Error("Break the loop.");
          }
          if (vl.passexp === '' || vl.passexp === 'null' || vl.passexp === null) {
            toast.error('Enter Passport Expiry Date ' + paxmsg, { autoclose: 2000 });
            continueform = false;
            throw new Error("Break the loop.");
          } else {

            const passexpiry = vl.passexp;
            const passexpiryMom = Moment(passexpiry, 'DD/MM/YYYY')
            const TravelDateMom = Moment(TravelDate)

            const age = passexpiryMom.diff(TravelDateMom, 'months', true);
            if (age <= 6) {
              toast.error('Passport Expiry Date cannot be less than 6 months from last travel date ' + paxmsg, { autoclose: 2000 });
              continueform = false;
              throw new Error("Break the loop.");
            }

          }
        }


      })
    } catch (error) {
    }

    if (BookingData[0].isGSTMandatory && BookOffline === false) {
      if (!data.isgstapply) {
        toast.error('GSTIN is mandatory for this airline.', { autoClose: 2000 });
        return false;
      }
    }
    if (data.isgstapply) {
      if (data.gstnnumber === '') {
        toast.error('Please enter the valid GSTIN number', { autoClose: 2000 });
        return false;
      }
      if (data.companyname === '') {
        toast.error('Please enter company name', { autoClose: 2000 });
        return false;
      }
      if (data.gstemail === '') {
        toast.error('Please enter registered email id', { autoClose: 2000 });
        return false;
      }
      if (data.gstphone === '') {
        toast.error('Please enter registered phone number', { autoClose: 2000 });
        return false;
      }
      if (data.gstaddress === '') {
        toast.error('Please enter registered address', { autoClose: 2000 });
        return false;
      }
      if (data.gststate === '') {
        toast.error('Please enter registered state', { autoClose: 2000 });
        return false;
      }
    }

    if (continueform) {
      const membernewData = transformData(memberDetails);
      // console.log(membernewData);
      // return false;
      let gstInfo = null
      if (data.isgstapply) {
        gstInfo = {
          GstNumber: data.gstnnumber,
          GstCompany: data.companyname,
          GstEmail: data.gstemail,
          GstPhone: data.gstphone,
          GstAddress: data.gstaddress,
          GstState: data.gststate,
        }
      }

      const SaveItinirary = {
        "isAppBooking": true,
        "BookingType": 2,
        // "isGoertCarePlus": true,
        "BookingID": BookingData[0].searchId,
        "travellerInfo": membernewData,
        "currency": currency,
        "gstInfo": gstInfo,
        "deliveryInfo": {
          "emails": data.email,
          "contacts": data.mobile,
          "countrycode": data.countryCode
        }
      }

      setSavepax(true)
      try {
        const response = await dispatch(
          SavePassenger({ SaveItinirary, currency })
        ).unwrap();
        if (response.data.status.success) {
          navigate(`/flight/review/${BookingData[0].searchId}`);
        } else {
          setSavepax(false)
          toast.error(response.data.message, { autoClose: 2000 });
        }
        // console.log("API Response:", response);
      } catch (error) {
        setSavepax(false)
        console.error("Error:", error);
      }

    }
  };

  const handleAddons = (event, index) => {
    let bb = 0;
    let ml = 0;
    let selectedBagAR = [];
    let selectedMealAR = [];
    const selectedBad = document.querySelectorAll(".selectedBad");
    const selectedMeal = document.querySelectorAll(".selectedMeal");
    [...selectedBad].forEach(vl => {
      if (vl.value !== 'NA') {
        selectedBagAR.push(vl.value);
        const BagArray = vl.value.split('@@');
        const bagPrice = Number(BagArray[1]);
        bb += bagPrice;
      }
    });
    [...selectedMeal].forEach(vl => {
      if (vl.value !== 'NA') {
        selectedMealAR.push(vl.value);
        const MealArray = vl.value.split('@@');
        const mealPrice = Number(MealArray[1]);
        ml += mealPrice;
      }
    });
    setTotalBagPrice(bb)
    setTotalMealPrice(ml)
    setTotalSSR(bb + ml)
    setSelectedBaggage(selectedBagAR);
    setSelectedMeals(selectedMealAR);
  }
  const parsedContent = useParsedContent(
    BookingData[0]?.FareLists?.OffNote || ""
  );

  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setCustomerMemberload(0); // close dropdown
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <>
      {isLoading ? (
        <>
          <div className="flex items-center justify-center space-x-12 px-8 py-4 bg-white shadow">
            <Step icon={<Plane className="w-5 h-5 text-white" />} title="FIRST STEP" subtitle="Flight Itinerary" active />
            <Step icon={<User className="w-5 h-5 text-gray-400" />} title="SECOND STEP" subtitle="Passenger Details" />
            <Step icon={<CheckCircle className="w-5 h-5 text-gray-400" />} title="THIRD STEP" subtitle="Review" />
            <Step icon={<CreditCard className="w-5 h-5 text-gray-400" />} title="FINISH STEP" subtitle="Payments" />
          </div>
          <ItineraryLoader />
        </>
      ) : (
        <div className="bg-gray-50 min-h-screen pb-16 mt-2" ref={targetRef}>
          {/* Stepper */}
          <div className="flex items-center justify-center space-x-12 px-8 py-4 bg-white shadow">
            <Step icon={<Plane className="w-5 h-5 text-white" />} title="FIRST STEP" subtitle="Flight Itinerary" active />
            <Step icon={<User className="w-5 h-5 text-gray-400" />} title="SECOND STEP" subtitle="Passenger Details" />
            <Step icon={<CheckCircle className="w-5 h-5 text-gray-400" />} title="THIRD STEP" subtitle="Review" />
            <Step icon={<CreditCard className="w-5 h-5 text-gray-400" />} title="FINISH STEP" subtitle="Payments" />
          </div>

          <div className="flex flex-col md:flex-row gap-6 max-w-7xl mx-auto mt-6 px-4">
            {/* Flight details */}
            <div className="flex-1 space-y-6">
              {(BookingData[0]?.FareLists.OffNote && BookingData[0]?.FareLists.discountOffline > 0) && (
                < div className="text-lg text-red-600 text-center font-normal bg-white p-2">
                  {parsedContent}
                </div>
                // <div className="text-lg font-normal text-red-600 text-center bg-white p-2" dangerouslySetInnerHTML={{ __html: BookingData[0]?.FareLists.OffNote.replace(/__nls__/g, '') }}></div>
              )}

              {BookingData.map((f, idx) => (
                <div key={idx} className="bg-white rounded-lg shadow p-4 space-y-4">
                  <div className="flex items-center justify-between">
                    <h3 className="font-semibold">
                      {f.SoCity} → {f.DeCity}{" "}
                      <span className="text-sm font-normal text-gray-500">
                        on {format(new Date(f.FromUTCTime), "MMM dd, EEE, HH:mm")}
                      </span>
                    </h3>
                    <span className="text-sm text-gray-500 flex items-center gap-1">
                      <Clock className="w-4 h-4" /> {f.Duration}
                    </span>
                  </div>

                  {f.Segments.map((SegItem, Segkey) => (
                    <div key={Segkey}>
                      <div className="flex gap-4">
                        <div className="w-12 h-12 rounded-md overflow-hidden bg-gray-100 flex items-center justify-center p-1">
                          <img
                            src={SegItem.filePath}
                            alt={SegItem.AirlineName}
                            className="object-contain rounded-md w-full h-full"
                          />
                        </div>

                        <div className="flex-1">
                          <p className="font-semibold">
                            {SegItem.AirlineName}{" "}
                            <span className="text-gray-500">{SegItem.FlightNumber}</span>
                          </p>

                          <div className="flex items-center gap-6 mt-2">
                            <div>
                              <p className="font-bold">{format(new Date(SegItem.originDepTime), "MMM dd, EEE, HH:mm")}</p>
                              <p className="text-sm text-gray-600">
                                {SegItem.originCityName}, {SegItem.originCountryName}
                              </p>
                              <p className="text-sm text-gray-600">{SegItem.originAirportName}</p>
                              <p className="text-xs text-gray-400">Terminal {SegItem.DepTerminal}</p>
                            </div>

                            <ArrowRight className="w-6 h-6 text-gray-400" />

                            <div>
                              <p className="font-bold">{format(new Date(SegItem.destinationArrTime), "MMM dd, EEE, HH:mm")}</p>
                              <p className="text-sm text-gray-600">
                                {SegItem.destinationCityName}, {SegItem.destinationCountryName}
                              </p>
                              <p className="text-sm text-gray-600">{SegItem.destinationAirportName}</p>
                              <p className="text-xs text-gray-400">Terminal {SegItem.ArrTerminal}</p>
                            </div>

                            <div>
                              <p className="font-bold">{SegItem.FlightDuration}</p>
                              <p className="text-sm text-gray-600">{f.FareLists.FareClass}</p>
                              <p className="text-xs text-gray-400">{f.FareLists.RefundableTxt}</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Layover (if not last segment) */}
                      {SegItem.GroundTime > 0 && (
                        <div className="text-center my-4">
                          <span className="bg-blue-500 text-white text-xs px-3 py-1 rounded-full font-medium">
                            Change Plane at {SegItem.LAYOVERCity}, Layover Time : {SegItem.LAYOVERDuration}
                          </span>
                        </div>
                      )}

                      <div className="text-sm text-gray-600 border-b pt-2 pb-2">
                        <p>
                          🧳 (Adult) Check-in:{f.FareLists.Checkin} Cabin: {f.FareLists.Cabin}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              ))}

              <form onSubmit={SavePaxSubmit} className="mui-form">
                <>
                  <div className="bg-white shadow-md rounded-lg p-4 mt-4">
                    {/* Header */}
                    <div className="flex items-start justify-between">
                      <h3 className="text-lg font-semibold text-gray-800">
                        Contact Details
                      </h3>
                    </div>
                    <hr className="border-t border-gray-200 my-3" />
                    <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-600">Country Code</label>
                        <select
                          className="mt-1 block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 transition-all"
                          value={data?.countryCode}
                          name="countryCode"
                          onChange={handleChange}
                        >
                          {nationality.map((item, key) => (
                            <option key={item.countryid} value={item.dial_code}>{item.countryname} +{item.dial_code}</option>
                          ))}
                        </select>
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-600">Mobile</label>
                        <input
                          type="text"
                          className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                          placeholder="Enter Mobile Number"
                          value={data?.mobile} onChange={handleChange}
                          name="mobile"
                        />
                      </div>

                      <div className="sm:col-span-2 relative">
                        <label className="block text-sm font-medium text-gray-600">Email</label>
                        <input
                          type="text"
                          className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                          placeholder="Enter Email ID"
                          value={data?.email} onChange={handleChange}
                          name="email"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="bg-white shadow-md rounded-lg p-4 mt-4">
                    {/* Header */}
                    <div className="flex items-start justify-between">
                      <h3 className="text-lg font-semibold text-gray-800">
                        Travellers Details
                      </h3>
                      <em className="text-xs text-gray-500">
                        Name & other details should be same as in Government ID proof
                      </em>
                    </div>
                    <hr className="border-t border-gray-200 my-3" />
                    {memberDetails.map((pitem, index) => {
                      const { minDate, maxDate } = getDobRange(pitem.pax, TravelDate);
                      const { minDate: issueMin, maxDate: issueMax } = getPassportIssueRange();
                      const { minDate: expMin, maxDate: expMax } = getPassportExpiryRange(TravelDate);
                      return (
                        <div key={index} className="mb-5">
                          {pitem.PaxCount == 1 && (
                            <div className="flex flex-wrap items-center mb-2">
                              <div className="w-full sm:w-1/2 mb-2 sm:mb-0">
                                <div className="font-semibold text-gray-700">
                                  {pitem.pax} ({pitem.AgeR})
                                </div>
                              </div>
                              <div className="w-full sm:w-1/2" />
                            </div>
                          )}

                          {/* Main checkbox row */}
                          <div className="mt-2">
                            <div className="mb-2">
                              <label
                                htmlFor={pitem.pax + '' + pitem.PaxCount}
                                className="inline-flex items-center space-x-2 cursor-pointer select-none"
                              >
                                <input
                                  type="checkbox"
                                  checked={pitem.checked}
                                  value={pitem.index}
                                  id={pitem.pax + '' + pitem.PaxCount}
                                  name="checked"
                                  readOnly
                                  index={pitem.index}
                                  className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                />
                                <span className="text-sm text-gray-800">
                                  {pitem.title === ''
                                    ? pitem.pax + ' ' + pitem.PaxCount
                                    : pitem.title + ' ' + pitem.fname + ' ' + pitem.lname}
                                </span>
                              </label>
                            </div>
                          </div>

                          {pitem.checked && (
                            <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                              {/* Title */}
                              <div>
                                <label className="block text-sm font-medium text-gray-600">Title</label>
                                {pitem.PaxType == 1 ? (
                                  <select
                                    disabled={FormData?.reissue}
                                    className="mt-1 block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 transition-all"
                                    value={pitem.title}
                                    name="title"
                                    onChange={(event) => handleFormChange(event, index)}
                                    id={pitem.index + 'salution'}
                                    index={pitem.index}
                                  >
                                    <option value="">Title</option>
                                    <option value="MR">Mr.</option>
                                    <option value="MRS">Mrs.</option>
                                    <option value="MS">Ms.</option>
                                  </select>
                                ) : (
                                  <select
                                    disabled={FormData?.reissue}
                                    className="mt-1 block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 transition-all"
                                    value={pitem.title}
                                    name="title"
                                    onChange={(event) => handleFormChange(event, index)}
                                    id={pitem.index + 'salution'}
                                    index={pitem.index}
                                  >
                                    <option value="">Title</option>
                                    <option value="MISS">Miss.</option>
                                    <option value="MASTER">Master.</option>
                                  </select>
                                )}
                              </div>

                              {/* First Name (relative wrapper for dropdown) */}
                              <div className="relative">
                                <label className="block text-sm font-medium text-gray-600">First Name</label>
                                <input
                                  disabled={FormData?.reissue}
                                  type="text"
                                  ref={inputRef}
                                  autoComplete="off"
                                  className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                                  onKeyUp={(e) => {
                                    SearchMember(e, index, pitem.PaxType);
                                  }}
                                  onClick={(e) => {
                                    SearchMember(e, index, pitem.PaxType);
                                  }}
                                  placeholder="Enter First Name"
                                  value={pitem.fname}
                                  onChange={(event) => handleFormChange(event, index)}
                                  id={pitem.index + 'fname'}
                                  name="fname"
                                />
                                {CustomerMemberload == index + 1 && CustomerMem.length > 0 && (
                                  <div ref={dropdownRef} className="country_dropdown" style={{ top: '68px' }}>
                                    <ul className="allcountries">
                                      {CustomerMem.length > 0 && (
                                        <>
                                          {
                                            CustomerMem.map((items, key) => (
                                              <li key={key} onClick={() => { setCustomerMemberload(0); handleMemberSelect(items, index); }}>
                                                <div style={{ color: '#377aff', fontSize: '14px' }}>{items.title}. {items.name}</div>
                                                <span style={{ fontSize: '12px' }}>
                                                  {(() => {
                                                    if (items.PaxType == 1) {
                                                      return <><b>ADULT</b></>
                                                    } else if (items.PaxType == 2) {
                                                      return <><b>CHILD</b></>
                                                    } else {
                                                      return <><b>INFANT</b></>
                                                    }
                                                  })()}
                                                  - {items.passno}
                                                </span>
                                              </li>
                                            ))
                                          }
                                        </>
                                      )}
                                    </ul>
                                  </div>
                                )}
                              </div>



                              {/* Last Name */}
                              <div>
                                <label className="block text-sm font-medium text-gray-600">Last Name</label>
                                <input
                                  disabled={FormData?.reissue}
                                  type="text"
                                  className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                                  placeholder="Enter Last Name"
                                  value={pitem.lname}
                                  onChange={(event) => handleFormChange(event, index)}
                                  id={pitem.index + 'lname'}
                                  name="lname"
                                />
                              </div>
                              {/* DOB */}
                              {pitem.isdobr && (
                                <div>
                                  <label className="block text-sm font-medium text-gray-600">
                                    Date Of Birth <span className="text-[10px]">(dd-mm-yyyy)</span>
                                  </label>
                                  <DateInput
                                    placeholder="dd-mm-yyyy"
                                    valueFormat="DD-MM-YYYY"
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    defaultLevelValue={maxDate}
                                    className="w-full"
                                    value={pitem.dob}
                                    onChange={(date) => {
                                      if (!date) {
                                        handleFormChange("dob", index, null);
                                        return;
                                      }
                                      const normalized = dayjs(date).format("YYYY-MM-DD");             // ← always "1990-10-07"
                                      handleFormChange("dob", index, normalized);
                                    }}
                                    rightSection={<Calendar size={18} className="text-gray-500" />}
                                    fixOnBlur={false}
                                    dateParser={(input) => {
                                      const parsed = dayjs(input, "DD-MM-YYYY", true);
                                      return parsed.isValid() ? parsed.toDate() : null;
                                    }}
                                    ref={dobRef}
                                    onInput={formatDateInput}   // ← handles auto dash insertion
                                  />

                                </div>
                              )}
                              {/* IsDocIdM */}
                              {pitem.IsDocIdM && (
                                <div>
                                  <label className="block text-sm font-medium text-gray-600">
                                    Valid ID Number <Info size={16} />
                                  </label>
                                  <input
                                    disabled={FormData?.reissue}
                                    maxLength="10"
                                    className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                                    type="text"
                                    value={pitem.docid}
                                    onChange={(event) => handleFormChange(event, index)}
                                    id={pitem.index + 'docid'}
                                    name="docid"
                                    placeholder="College ID etc.."
                                  />
                                </div>
                              )}

                              {/* Passport Nationality */}
                              {pitem.IsPassM && (
                                <div>
                                  <label className="block text-sm font-medium text-gray-600">Passport Nationality</label>
                                  <select
                                    disabled={FormData?.reissue}
                                    value={pitem.passnational}
                                    className="mt-1 block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 transition-all"
                                    onChange={(event) => handleFormChange(event, index)}
                                    name="passnational"
                                    id={pitem.index + 'passnational'}
                                  >
                                    {nationality.map((item, key) => (
                                      <option key={item.countryid} value={item.code}>
                                        {item.countryname} - {item.code}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              )}

                              {/* Passport No */}
                              {pitem.IsPassM && (
                                <div>
                                  <label className="block text-sm font-medium text-gray-600">
                                    Passport No. <span className="text-[10px]">(KF0192332C)</span>
                                  </label>
                                  <input
                                    disabled={FormData?.reissue}
                                    type="text"
                                    className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                                    value={pitem.passno}
                                    onChange={(event) => handleFormChange(event, index)}
                                    id={pitem.index + 'passno'}
                                    name="passno"
                                    placeholder="Enter passport no."
                                  />
                                </div>
                              )}

                              {/* Passport Issue */}
                              {pitem.IsPassM && (
                                <div>
                                  <label className="block text-sm font-medium text-gray-600">
                                    Passport Issue <span className="text-[10px]">(dd-mm-yyyy)</span>
                                  </label>
                                  {/* <DateInput
                                    placeholder="dd-mm-yyyy"
                                    valueFormat="DD-MM-YYYY"
                                    minDate={issueMin}
                                    maxDate={issueMax}
                                    defaultLevelValue={issueMax} // open near today
                                    className="w-full"
                                    value={pitem.passisse}
                                    onChange={(date) => handleFormChange("passisse", index, date)}
                                    rightSection={<Calendar size={18} className="text-gray-500" />} // 👈 custom calendar icon
                                  /> */}

                                  <DateInput
                                    placeholder="dd-mm-yyyy"
                                    valueFormat="DD-MM-YYYY"
                                    minDate={issueMin}
                                    maxDate={issueMax}
                                    defaultLevelValue={issueMax}
                                    className="w-full"
                                    value={pitem.passisse}
                                    onChange={(date) => {
                                      if (!date) {
                                        handleFormChange("passisse", index, null);
                                        return;
                                      }
                                      const normalized = dayjs(date).format("YYYY-MM-DD");             // ← always "1990-10-07"
                                      handleFormChange("passisse", index, normalized);
                                    }}
                                    rightSection={<Calendar size={18} className="text-gray-500" />}
                                    fixOnBlur={false}
                                    dateParser={(input) => {
                                      const parsed = dayjs(input, "DD-MM-YYYY", true);
                                      return parsed.isValid() ? parsed.toDate() : null;
                                    }}
                                    ref={dobRef}
                                    onInput={formatDateInput}   // ← handles auto dash insertion
                                  />
                                </div>
                              )}

                              {/* Passport Expiry */}
                              {pitem.IsPassM && (
                                <div>
                                  <label className="block text-sm font-medium text-gray-600">
                                    Passport Expiry <span className="text-[10px]">(dd-mm-yyyy)</span>
                                  </label>
                                  {/* <DateInput
                                    placeholder="dd-mm-yyyy"
                                    valueFormat="DD-MM-YYYY"
                                    minDate={expMin}
                                    maxDate={expMax}
                                    defaultLevelValue={expMin} // open around earliest valid expiry
                                    className="w-full"
                                    value={pitem.passexp}
                                    onChange={(date) => handleFormChange("passexp", index, date)}
                                    rightSection={<Calendar size={18} className="text-gray-500" />} // 👈 custom calendar icon
                                  /> */}

                                  <DateInput
                                    placeholder="dd-mm-yyyy"
                                    valueFormat="DD-MM-YYYY"
                                    minDate={expMin}
                                    maxDate={expMax}
                                    defaultLevelValue={expMin}
                                    className="w-full"
                                    value={pitem.passexp}
                                    onChange={(date) => {
                                      if (!date) {
                                        handleFormChange("passexp", index, null);
                                        return;
                                      }
                                      const normalized = dayjs(date).format("YYYY-MM-DD");             // ← always "1990-10-07"
                                      handleFormChange("passexp", index, normalized);
                                    }}
                                    rightSection={<Calendar size={18} className="text-gray-500" />}
                                    fixOnBlur={false}
                                    dateParser={(input) => {
                                      const parsed = dayjs(input, "DD-MM-YYYY", true);
                                      return parsed.isValid() ? parsed.toDate() : null;
                                    }}
                                    ref={dobRef}
                                    onInput={formatDateInput}   // ← handles auto dash insertion
                                  />
                                </div>
                              )}

                              {/* Wheelchair */}
                              {pitem.PaxType != 3 && (
                                <div className="flex items-end">
                                  <label
                                    htmlFor={pitem.index + 'wchr'}
                                    className="inline-flex items-center space-x-2 cursor-pointer select-none"
                                  >
                                    <input
                                      type="checkbox"
                                      checked={pitem.wchr}
                                      id={pitem.index + 'wchr'}
                                      name="wchr"
                                      onChange={(event) => handleFormChange(event, index)}
                                      className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                    />
                                    <span className="text-sm text-gray-800">Wheel Chair</span>
                                  </label>
                                </div>
                              )}

                              {/* Frequent Flyer */}
                              {pitem.PaxType != 3 && (
                                <div className="sm:col-span-2 md:col-span-3 lg:col-span-4 rounded-lg border border-gray-100 p-4 hidden">
                                  {/* <div className="w-full">
                                    <h5 className="text-sm font-medium">
                                      <span
                                        onClick={toggleFrequentflyer}
                                        className="text-[0.9rem] text-blue-600 cursor-pointer"
                                        style={{ fontSize: '0.9rem', color: '#3082ce', cursor: 'pointer' }}
                                      >
                                        {Frequentflyer ? '(-)' : '(+)'}&nbsp;FREQUENT FLIER NUMBER (OPTIONAL)
                                      </span>
                                    </h5>
                                  </div> */}

                                  {/* {Frequentflyer && pitem.FFdetail.length > 0 && (
                                    <div className="mt-3 grid grid-cols-1 sm:grid-cols-3 gap-4">
                                      {pitem.FFdetail.map((FFcode, keyss) => (
                                        <React.Fragment key={keyss}>
                                          <div>
                                            <label
                                              htmlFor={'FFAirlineCode' + index + keyss}
                                              className="block text-sm font-medium text-gray-600"
                                              style={{ fontWeight: '400' }}
                                            >
                                              Airline Code
                                            </label>
                                            <input
                                              type="text"
                                              readOnly
                                              className="mt-1 block w-full rounded-lg border border-gray-300 bg-gray-100 px-3 py-2 text-sm text-gray-700 focus:outline-none"
                                              id={'FFAirlineCode' + index + keyss}
                                              name="FFAirlineCode"
                                              value={FFcode.FFAirlineCode}
                                              onChange={(event) => handleFormChange(event, index, keyss)}
                                              placeholder="Airline"
                                            />
                                          </div>
                                          <div className="sm:col-span-2">
                                            <label
                                              htmlFor={'FFNumber' + index + keyss}
                                              className="block text-sm font-medium text-gray-600"
                                              style={{ fontWeight: '400' }}
                                            >
                                              Frequent flyer no.
                                            </label>
                                            <input
                                              type="text"
                                              className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                                              id={'FFNumber' + index + keyss}
                                              name="FFNumber"
                                              value={FFcode.FFNumber}
                                              onChange={(event) => handleFormChange(event, index, keyss)}
                                              placeholder="Frequent flyer no."
                                            />
                                          </div>
                                        </React.Fragment>
                                      ))}
                                    </div>
                                  )} */}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      )
                    })}

                    {(BookOffline === false && Supplier !== 7) && (
                      <>
                        <div className="flex items-center justify-between">
                          <h3 className="text-lg font-semibold text-gray-800">
                            Select Seat
                          </h3>

                          {(Supplier === 6 || Supplier === 11) && (
                            <button
                              type="button"
                              onClick={getSeatMap}
                              className="px-5 py-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white font-medium shadow transition"
                            >
                              Continue with seat
                            </button>
                          )}
                        </div>
                        <hr className="border-t border-gray-200 my-3" />
                        {(SeatLoading) && (
                          <div className="max-w-4xl mx-auto">
                            <ShimmerLoaderSeat />
                            <ShimmerLoaderSeat />
                          </div>
                        )}
                        {SeatDataSuccess === true && (
                          <div className="max-w-4xl mx-auto">
                            <SeatSelection Allsegment={Allsegment} SeatData={SeatData} memberDetails={memberDetails} setSelectedSeats={setSelectedSeats} setTotalSeatPrice={setSeatPrice} totalPax={totalPax} setMemberDetails={setMemberDetails} />
                          </div>
                        )}

                        {SeatDataSuccess === false && (
                          <>
                            <div className="max-w-4xl mx-auto p-4">
                              Seat not applicable for this flight
                            </div>
                          </>
                        )}
                        <div className="flex items-start justify-between">
                          <h3 className="text-lg font-semibold text-gray-800">
                            Select Baggage & Meal (Optional)
                          </h3>
                        </div>
                        <hr className="border-t border-gray-200 my-3" />
                        <div className="max-w-4xl mx-auto p-4">
                          {Allsegment.map((itemSg, keys) => (
                            <div key={keys} className="mb-6">
                              {/* Route and Date */}
                              <h2 className="text-lg font-semibold mb-3">
                                {itemSg.originCityName} - {itemSg.destinationCityName}
                                <span className="text-gray-600 font-normal text-sm">
                                  &nbsp;On {Moment(itemSg.originDepTime).format('MMM Do YYYY')}
                                </span>
                              </h2>

                              {/* Passenger rows */}
                              <div className="space-y-3">
                                {memberDetails.map((pitem, index) => (
                                  <div
                                    key={index}
                                    className="grid grid-cols-1 md:grid-cols-3 gap-3 items-center"
                                  >
                                    {pitem.addonns && (
                                      <>
                                        <div className="text-sm font-medium text-gray-700"> {pitem.pax + ' ' + pitem.PaxCount}</div>
                                        {/* Baggage dropdown */}

                                        {itemSg.BAGGAGE.length > 0 ? (
                                          <select onChange={event => handleAddons(event, index)} name="selectedBad" className='w-full border rounded-md px-3 py-2 text-gray-600 focus:outline-none focus:ring-2 focus:ring-[#f4a406] selectedBad'>
                                            <option value="NA" >Add Baggage</option>
                                            {itemSg.BAGGAGE.map((val, bi) => (
                                              <>
                                                {val.Price > 0 ? (
                                                  <option key={bi} value={pitem.pax + '' + pitem.PaxCount + '_' + val.Code + '@' + val.key + '_' + itemSg.originAirportCode + '-' + itemSg.destinationAirportCode + '@@' + val.Price} >{val.Weight} @ {val.symbol} {val.Price}</option>
                                                ) : (
                                                  <>
                                                    {bi === 0 && (
                                                      <option value="NA" defaultValue="NA" >Same as above</option>
                                                    )}
                                                  </>

                                                )}
                                              </>
                                            ))}
                                          </select>
                                        ) : (
                                          <select onChange={event => handleAddons(event, index)} name="selectedBad" className='w-full border rounded-md px-3 py-2 text-gray-600 focus:outline-none focus:ring-2 focus:ring-[#f4a406] selectedBad'>
                                            <option value="NA" >Same as above</option>
                                          </select>
                                        )}
                                        {/* Meal dropdown */}

                                        {itemSg.MEAL && (
                                          <select onChange={event => handleAddons(event, index)} name="selectedMeal" className='w-full border rounded-md px-3 py-2 text-gray-600 focus:outline-none focus:ring-2 focus:ring-[#f4a406] selectedMeal'>
                                            <option value="NA" >Add Meal</option>
                                            {itemSg.MEAL.map((val, bi) => (
                                              <option key={bi} value={pitem.pax + '' + pitem.PaxCount + '_' + val.Code + '@' + val.key + '_' + itemSg.originAirportCode + '-' + itemSg.destinationAirportCode + '@@' + val.Price} >{val.Description} @ {val.symbol} {val.Price}</option>
                                            ))}
                                          </select>
                                        )}
                                      </>
                                    )}
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                        <hr className="border-t border-gray-200 my-3" />
                        <div className="flex items-start justify-between">
                          <h3 className="text-lg font-semibold text-gray-800">
                            <label className="flex items-center gap-2">
                              <input type="checkbox" value="1" className="accent-blue-500 w-5 h-5" onClick={isgstapplyhandle} />
                              <span className="font-semibold">GST Number for Business Travel (Optional)</span>
                            </label>
                          </h3>
                        </div>
                        {data.isgstapply && (
                          <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
                            <div>
                              <label className="block text-sm font-medium text-gray-600">GST (GSTIN)</label>
                              <input
                                type="text"
                                className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                                placeholder="GST (GSTIN)"
                                value={data.gstnnumber}
                                onChange={handleChange}
                                id="gstnnumber"
                                name="gstnnumber"
                              />
                            </div>
                            <div>
                              <label className="block text-sm font-medium text-gray-600">Company name</label>
                              <input
                                type="text"
                                className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                                placeholder="Company name"
                                value={data.companyname}
                                onChange={handleChange}
                                id="companyname"
                                name="companyname"
                              />
                            </div>
                            <div>
                              <label className="block text-sm font-medium text-gray-600">Registered Email</label>
                              <input
                                type="text"
                                className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                                placeholder="Registered Email"
                                value={data.gstemail}
                                onChange={handleChange}
                                id="gstemail"
                                name="gstemail"
                              />
                            </div>
                            <div>
                              <label className="block text-sm font-medium text-gray-600">Registered Phone</label>
                              <input
                                type="text"
                                className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                                placeholder="Registered Phone"
                                value={data.gstphone}
                                onChange={handleChange}
                                id="gstphone"
                                name="gstphone"
                              />
                            </div>
                            <div>
                              <label className="block text-sm font-medium text-gray-600">Registered Address</label>
                              <input
                                type="text"
                                className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                                placeholder="Registered Address"
                                value={data.gstaddress}
                                onChange={handleChange}
                                id="gstaddress"
                                name="gstaddress"
                              />
                            </div>
                            <div>
                              <label className="block text-sm font-medium text-gray-600">Registered State</label>
                              <input
                                type="text"
                                className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                                placeholder="Registered State"
                                value={data.gststate}
                                onChange={handleChange}
                                id="gststate"
                                name="gststate"
                              />
                            </div>
                          </div>
                        )}
                      </>
                    )}

                    <hr className="border-t border-gray-200 my-3" />

                    {/* Footer buttons */}
                    <div className="flex items-center justify-between pt-2">
                      <button
                        variant="contained"
                        size="large"
                        type="button"
                        className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                      >
                        Back
                      </button>


                      <button
                        variant="contained"
                        size="large"
                        type="submit"
                        disabled={Savepaxloading}
                        className={`px-5 py-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white font-medium shadow transition ${Savepaxloading
                          ? 'bg-gray-400 cursor-not-allowed'
                          : 'bg-blue-500 hover:bg-blue-600'
                          }`}
                      >
                        {Savepaxloading ? (
                          <>
                            Please wait...
                          </>
                        ) : (
                          'Continue'
                        )}
                      </button>
                    </div>
                  </div>

                </>
              </form>


            </div>

            {/* Fare summary sidebar */}
            <aside className="w-full md:w-80 self-start md:sticky md:top-4 self-start max-h-[calc(100vh-2rem)] overflow-y-auto">
              {/* <h3 className="font-semibold">Fare Summary</h3> */}
              <FareSummary params={params} fare={fare} BookingData={BookingData} SeatPrice={SeatPrice} TotalBagPrice={TotalBagPrice} TotalMealPrice={TotalMealPrice} TotalSSR={TotalSSR} user={user} />
              <div className="w-full max-w-md mx-auto p-2 bg-white rounded-lg border border-gray-200 mt-4">
                {/* Header */}
                <div className="flex items-center justify-between mb-3">
                  <h3 className="font-semibold">Offers & Promo Code</h3>
                  <img
                    src="/icocoupn.svg"
                    alt="promo"
                    className="w-6 h-6"
                  />
                </div>

                <div className={"mb-4"}>
                  <p className="text-gray-600 text-sm mt-2 font-medium">
                    "Great news! All available promo codes are waiting for you on the final page. Apply one and enjoy instant savings before you pay."
                  </p>
                </div>
              </div>
              {/* <div className="flex justify-between text-sm">
                <span>Base fare</span>
                <span>00</span>
              </div>

              <div className="flex justify-between text-sm">
                <span>Taxes and fees</span>
                <span>00</span>
              </div>

              <div className="flex justify-between text-lg font-bold border-t pt-2">
                <span>Amount to Pay</span>
                <span>00</span>
              </div> */}

              {/* <div className="border rounded-lg p-3">
                <p className="text-sm">
                  TJ Cash: <span className="font-semibold">1 TJ Cash = ₹1</span>
                </p>
                <div className="flex mt-2 gap-2">
                  <input
                    type="text"
                    placeholder="Enter TJ Cash"
                    className="flex-1 border rounded px-2 py-1 text-sm"
                  />
                  <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-1 rounded text-sm font-semibold">
                    REDEEM
                  </button>
                </div>
              </div> */}
            </aside>
          </div>

          {/* Fixed session expiry */}
          {/* <div className="fixed bottom-0 left-0 right-0 bg-black text-white text-center py-2 z-50">
            Your Session will expire in{" "}
            <span className="font-bold">{formatTime(timeLeft)}</span>
          </div> */}
        </div >
      )
      }
    </>
  );
}

// Stepper component
const Step = ({ icon, title, subtitle, active }) => (
  <div className="flex items-center flex-1">
    <div
      className={`flex items-center justify-center w-10 h-10 rounded-full flex-shrink-0 ${active ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-500"
        }`}
    >
      {icon}
    </div>
    <div className="ml-2">
      <p
        className={`text-sm ${active ? "font-bold text-blue-500" : "text-gray-600"
          }`}
      >
        {title}
      </p>
      <span className="text-xs text-gray-400">{subtitle}</span>
    </div>
  </div>
);
